import groq from 'groq';

export const PLP_HREF = groq`
"href": select(
  category == "skincare" && defined(slug) => "/skincare/shop/" + slug.current,
  category == "skincare" => "/skincare/shop",
  defined(slug) => "/shop/" + slug.current,
  "/shop"
)
`;
